var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"switch"},[_c('input',{attrs:{"name":_vm.name,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"click":_vm.toggle}}),_c('span',{staticClass:"slider round"})])}
var staticRenderFns = []

export { render, staticRenderFns }